import { createContext, useContext } from "react";
import { DEFAULT_MARKETING_CONFIG, type MarketingConfig } from "@/lib/site-marketing";

const MarketingConfigContext = createContext<MarketingConfig>(DEFAULT_MARKETING_CONFIG);

/**
 * Provee la configuración de marketing/tracking (cargada en SSR por el loader raíz)
 * a los componentes del sitio. Sin provider, retorna DEFAULT_MARKETING_CONFIG.
 */
export function MarketingConfigProvider({
  value,
  children,
}: {
  value: MarketingConfig;
  children: React.ReactNode;
}) {
  return (
    <MarketingConfigContext.Provider value={value}>{children}</MarketingConfigContext.Provider>
  );
}

/** Devuelve siempre un MarketingConfig válido (defaults si no hay provider). */
// eslint-disable-next-line react-refresh/only-export-components
export function useMarketingConfig(): MarketingConfig {
  return useContext(MarketingConfigContext);
}
